import React, { createContext, useState } from 'react';

import OmeMeetOrgUnitAthleteEntryRelayRosterEntryData from './OmeMeetOrgUnitAthleteEntryRelayRosterEntryData';

export const OmeMeetOrgUnitAthleteEntryRelayRosterEntryStateContext = createContext();

const OmeMeetOrgUnitAthleteEntryContextRelayRosterEntryProvider = ({ children }) => {
  const stateHook = useState(OmeMeetOrgUnitAthleteEntryRelayRosterEntryData.INITIAL_STATE);

  return (
    <OmeMeetOrgUnitAthleteEntryRelayRosterEntryStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetOrgUnitAthleteEntryRelayRosterEntryStateContext.Provider>
  );
};

export default OmeMeetOrgUnitAthleteEntryContextRelayRosterEntryProvider;